import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import CIPStatusItem
  from 'Views/Page/Content/Templates/WizardTemplates/CIPInformationVerificationTemplate/Content/CIPStatusItem';
import fr from 'facet-rest';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import { Box, Stack } from '@facet-wealth/design';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import useCIPInformationVerification
  from 'Views/Page/Content/Templates/WizardTemplates/CIPInformationVerificationTemplate/Content/useCIPInformationVerification';


const loadingCIPItems = [
  new fr.Resource({
    data: {
      id: 'NAME',
      attributes: {
        status: 'empty',
        label: 'Name',
        messages: [],
      },
    },
  }),
  new fr.Resource({
    data: {
      id: 'DOB',
      attributes: {
        status: 'empty',
        label: 'Date of Birth',
        messages: [],
      },
    },
  }),
  new fr.Resource({
    data: {
      id: 'TAX_ID',
      attributes: {
        status: 'empty',
        label: 'Tax Identification',
        messages: [],
      },
    },
  }),
  new fr.Resource({
    data: {
      id: 'ADDRESS',
      attributes: {
        status: 'empty',
        label: 'Address',
        messages: [],
      },
    },
  }),
];

export default function Content() {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    setPageContentCollection,
    refreshPageContentCollection,
  } = usePageContentContext();

  const { loading, cipStatusItems, retryCount } = useCIPInformationVerification(resource, setPageContentCollection, refreshPageContentCollection);

  let loadingItemIdx = -1;
  if (loading) {
    if (retryCount >= 7) {
      loadingItemIdx = 3;
    } else if (retryCount >= 5) {
      loadingItemIdx = 2;
    } else if (retryCount >= 3) {
      loadingItemIdx = 1;
    } else if (retryCount >= 1) {
      loadingItemIdx = 0;
    }
  }

  const shouldRetry = resource.withRelationship(fr.relationships.retryLink.name,
    () => true,
    () => false);

  // are we still in a state that requires sync but exceeded the retries?
  const loadingRetryExceeded = !loading && shouldRetry;

  let title = resource?.attr('title');
  let subtitle = resource?.attr('subtitle');
  if (loadingRetryExceeded) {
    title = 'It’s Not You, It’s Us';
    subtitle = 'We need a bit more time to finish opening this account. Feel free to leave this page, we’ll email you once this account is open.';
  }

  return <>
    <PageContentContainer maxWidth={'xs'}>
      <PageContentTop
        title={title}
        subtitle={subtitle}
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
      />
      {/* do not render cip items if loadingRetryExceeded.
       * if still loading, use the dummy list of CIP items (loadingCIPItems), otherwise use the response cipStatusItems
       */}
      {/* eslint-disable-next-line no-nested-ternary */}
      {loadingRetryExceeded ? null : (loading && (loadingItemIdx === -1)) ? <LoadingIndicator /> : (
        <Box width={'100%'}>
          <Stack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
            {(loading ? loadingCIPItems : cipStatusItems).map((cipStatusItem, idx) => (<CIPStatusItem
              key={cipStatusItem.id()}
              resource={cipStatusItem}
              loading={idx === loadingItemIdx}
            />))}
          </Stack>
        </Box>
      )}
    </PageContentContainer>
  </>;
}
